import React, { useEffect, useState } from "react";
import { ModalBody, Modal } from "reactstrap";
import styles from "./addbrand.module.scss";
import StepOne from "./StepOne";
import StepThree from "./StepThree";
import StepTwo from "./StepTwo";
import ReviewModal from "./ReviewModal";
import { addBrand, getProductCategories } from "../../../../helpers/service";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { setBrands } from "../../../Redux/Reducer/appReducer";


const AddBrandModal = ({ openModal, toggle, setLoading }) => {
  const brandsData = useSelector((state) => state?.appReducer)?.brands;
  const { idToken } = useSelector((state) => state?.authReducer);
  const [categories, setCategories] = useState([]);

  const dispatch = useDispatch();
  const [step, setStep] = useState(0);

  const AddBrandSchema = yup.object().shape({
    brandName: yup.string().required("Required"),
    parentCompany: yup.string().required("Required"),
    businessEntityName: yup.string().required("Required"),
    businessRegistrationNumber: yup.string().required("Required"),
    addressLine1: yup.string().required("Required"),
    country: yup.string().required("Required"),
    city: yup.string().required("Required"),
    state: yup.string().required("Required"),
    zipCode: yup.string().required("Required"),
  });


  const handleProductCategories = async () => {
    try {
      const categoriesData = await getProductCategories(idToken);
      setCategories(categoriesData?.data);
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  useEffect(() => {
    try {
      // Get all categories
      handleProductCategories();
    } catch (error) {
      console.error("Error: ", error);
    }
  }, []);

  const initialState = {
    brandName: "",
    parentCompany: "",
    businessEntityName: "",
    businessRegistrationNumber: "",
    addressLine1: "",
    addressLine2: "",
    country: "United States",
    city: "",
    state: "",
    zipCode: "",
    primaryProductCategory: "",
    descriptionOrBrand: "",
    role: "",
    name: "",
    email: "",
    status: "pending",
    file: "",
  };
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: AddBrandSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  const handleChange = (e) => {
    formik.handleChange(e);
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      // Create a FormData object
      const formData = new FormData();
      // Append all form values except the file
      for (const [key, value] of Object.entries(values)) {
        if (key !== "file") {
          formData.append(key, value);
        }
      }
      // Append the file to FormData if it exists
      if (values.file) {
        formData.append("file", values.file);
      }
      // Make the API call with FormData
      const brandData = await addBrand(formData, idToken);
      // Update the Redux store with the new brand data
      const newBrandsData = [
        ...brandsData,
        {
          ...brandData?.data,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      ];
      setLoading(false);
      dispatch(setBrands(newBrandsData));
      toast.success("Brand added successfully");
      formik.setSubmitting(false);
      formik.resetForm();
      toggle();
    } catch (error) {
      console.error("Error: ", error);
      toast.error("Something went wrong. Please try again.");
      setLoading(false);
      formik.setSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          formik.resetForm();
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_body"]}>
          {step === 1 ? (
            <StepTwo
              setStep={setStep}
              toggle={toggle}
              handleChange={handleChange}
              formik={formik}
              categories={categories}
            />
          ) : step === 2 ? (
            <StepThree
              setStep={setStep}
              toggle={toggle}
              handleChange={handleChange}
              formik={formik}
            />
          ) : step === 0 ? (
            <StepOne
              setStep={setStep}
              toggle={toggle}
              handleChange={handleChange}
              formik={formik}
            />
          ) : (
            <ReviewModal
              setStep={setStep}
              toggle={toggle}
              handleSubmit={() => {
                formik.submitForm();
              }}
              noErrors={Object?.keys(formik?.errors)?.length === 0}
              formikSubmitting={formik.isSubmitting}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddBrandModal;
